import {Injectable} from '@angular/core';

/**
 * Translations for club-overview statuses.
 */
@Injectable()
export class ClubStatusTranslationsService {
  public i18nActiveStatus: any = $localize`:@@general.status.active:Active`;
  public i18nInactiveStatus: any = $localize`:@@general.status.inactive:Inactive`;
  constructor() { }
}
